import { defineComponent as _defineComponent } from 'vue';
import { BAlert, BLink, BProgress } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { ref, watch } from "vue";
import { useUserFlagsStore } from "@/stores/userFlagsStore";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SelectionChangeWarning',
    props: {
        querySelectionBreak: { type: Boolean, default: true }
    },
    setup(__props) {
        const props = __props;
        const userFlagsStore = useUserFlagsStore();
        const { showSelectionQueryBreakWarning } = storeToRefs(useUserFlagsStore());
        const dismissSecs = ref(10);
        const dismissCountDown = ref(0);
        function onDismissed() {
            dismissCountDown.value = 0;
        }
        function onDoNotShowAgain() {
            onDismissed();
            userFlagsStore.ignoreSelectionQueryBreakWarning();
        }
        watch(() => props.querySelectionBreak, () => {
            dismissCountDown.value = showSelectionQueryBreakWarning ? dismissSecs.value : 0;
        });
        return { __sfc: true, props, userFlagsStore, showSelectionQueryBreakWarning, dismissSecs, dismissCountDown, onDismissed, onDoNotShowAgain, BAlert, BLink, BProgress };
    }
});
